import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  side: {
    backgroundColor: colors.backgroundGray,
    position: 'absolute',
    willChange: 'transform, opacity',
    backfaceVisibility: 'hidden',
    marginTop: 1
  },
  table: {
    overflowY: 'auto'
  },
  tableBottomFade: {
    position: 'relative',
    marginTop: -40,
    height: 40,
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), ${colors.backgroundGray})`
  }
}

export const useStyles = createUseStyles(style)
